export type StateEventParams = {
  stateEventType: string;
  stateEventArg?: string | number | boolean;
};
export type ButtonClickEventParams = {
  buttonText?: string;
  buttonVariant?: string;
  buttonSize?: string;
  buttonTrackingId?: string;
  buttonIndex?: number;
};
export type GameToastEventParams = {
  gameId?: string | number;
};
export type InputEventParams = {
  inputTrackingId?: string;
  inputLabel?: string;
  inputValue?: string;
  inputError?: string;
};
export type GameLaunchEventParams = { gameId?: string | number };
export type CategoryEventParams = {
  categoryId?: string | number;
  categoryTitle?: string;
};

export type RegistrationStepParams = {
  stepId: string;
  stepFields?: string;
};

export type LoginParams = {
  userId: string;
};

export type SignUpCompletedParams = {
  email: string;
  accountId: string;
};

export type DailyGiftClaimedParams = {
  rewardAmount: string;
  rewardType: string;
};

export type DailyRewardClickedParams = {
  status: string;
};

export type RegistrationCompletedParams = {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  accountId: string;
  advertiserTrackingEnabled: string;
  applicationTrackingEnabled: string;
  extinfo: string[];
  installId?: string;
  fbc?: string;
};

export type ATTEventParams = {
  permissionStatus: string;
};

export type TrackingParams =
  | StateEventParams
  | ButtonClickEventParams
  | InputEventParams
  | GameLaunchEventParams
  | CategoryEventParams
  | RegistrationStepParams
  | RegistrationCompletedParams
  | GameToastEventParams
  | ATTEventParams
  | LoginParams
  | SignUpCompletedParams
  | DailyGiftClaimedParams
  | DailyRewardClickedParams;

export type ScreenView = {
  screenName: string;
  screenClass?: string;
  screenPath?: string;
  screenParams?: object;
};

export type TrackEvent = {
  name: `${TrackingEvents}`;
  params?: TrackingParams;
};

export enum TrackingEvents {
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  SIGN_UP_STARTED = 'sign_up_started',
  SIGN_UP_COMPLETED = 'sign_up_completed',
  BUTTON_CLICK = 'button_click',
  INPUT_FOCUS = 'input_focus',
  INPUT_ERROR = 'input_error',
  HOME_WIDGET_CLICK = 'home_widget_click',
  CATEGORY_HOVER = 'category_hover',
  CATEGORY_CLICK = 'category_click',
  GAME_LAUNCH = 'game_launch',
  STATE_EVENT = 'state_event',
  SCREEN_VIEW = 'screen_view',
  REGISTRATION_STEP = 'registration_step',
  REGISTRATION_COMPLETED = 'registration_process_completed',
  GAMES_SEARCH_INPUT = 'games_search_input',
  LAST_LAUNCHED_GAME_TOAST_SHOWN = 'last_launched_game_toast_shown',
  LAST_LAUNCHED_GAME_TOAST_HIDDEN = 'last_launched_game_toast_hidden',
  ATT_STATUS = 'att_status',
  DAILY_GIFT_CLICKED = 'daily_gift_clicked',
  DAILY_GIFT_CLAIMED = 'daily_gift_claimed',
  DAILY_WHEEL_CLICKED = 'daily_wheel_clicked',
  DAILY_WHEEL_CLAIMED = 'daily_wheel_claimed',
  CUSTOM_WIDGET_LAUNCH_GAME = 'custom_widget_launch_game',
  CUSTOM_WIDGET_NAVIGATION_LOBBY = 'custom_widget_navigation_lobby',
  CUSTOM_WIDGET_NAVIGATE_CATEGORY = 'custom_widget_navigate_category',
}

export type InstallConversionData = {
  is_first_launch: 'true' | 'false';
  media_source: string;
  campaign: string;
  af_status: 'Organic' | 'Non-organic';
};

export type TrackingState = {
  installConversionData?: InstallConversionData;
  appsflyerUid?: string;
};
